import { matchPath } from 'react-router-dom';
import { ROUTES } from './urls';

/**
 * Routes that carry a project id in their `:id` param. Every project screen lives under
 * `/projects/details/:id` except the doc editor, which sits at `/projects/files/:id/docs/:docid`.
 * Anything that needs to answer "which project does this URL belong to?" should go through
 * `getProjectIdFromPath` so a newly added project route only has to be listed here.
 */
const PROJECT_ID_ROUTES = [ROUTES.PROJECT_DETAILS, ROUTES.PROJECT_DOCS];

/**
 * Resolves the project id owning a given path, or undefined when the path is not inside a project.
 * Accepts a pathname with or without a query string.
 */
export const getProjectIdFromPath = (pathname?: string): string | undefined => {
  const path = pathname?.split('?')[0];
  if (!path) return undefined;

  const match = PROJECT_ID_ROUTES.map((route) => matchPath<{ id: string }>(path, { path: route })).find(
    (result) => result?.params?.id
  );

  return match?.params?.id;
};
